module.exports = __webpack_public_path__ + "static/media/i-phone.93fee8e4.svg";